import {Badge} from '@/components/ui/badge/Badge'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {StyledPoint} from '@/features/projects/components/progress-status-badge/style'
import {ProjectExtended, ProjectProgressStatus} from '@/features/projects/types'
import {projectProgressStatusToIcon, projectProgressStatusToLabel} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'
import {useOutletContext} from 'react-router-dom'

export const ProgressStatusBadge = ({progressStatus}: {progressStatus: ProjectProgressStatus}) => {
    const {t} = useTranslation()
    const Icon = projectProgressStatusToIcon[progressStatus]
    const {project} = useOutletContext<{project: ProjectExtended}>()

    const progressStatusDescription = {
        incomplete: t('projects:verify_missing_data'),
        to_print: t('projects:projects_siar'),
        to_export: t('projects:projects_siar'),
        to_transmit: t('projects:confirm_transmitted_siar'),
        transmitted: t('projects:projects_siar')
    } as const satisfies Record<ProjectProgressStatus, string>

    if (progressStatus == 'to_transmit' && project.openingTransmissionAt && project.status != 'closed') {
        return null
    }

    return (
        <Flexbox gap={2} align="center">
            <Badge variant={progressStatus == 'incomplete' ? 'orange' : 'neutral'} size="sm" shape="roundedRectangle">
                <Icon />
                {t(projectProgressStatusToLabel[progressStatus])}
            </Badge>
            <Flexbox align="center" justify="center" gap={1}>
                <StyledPoint />
                <Text size="textSm" palette="neutral" shade="600">
                    {progressStatusDescription[progressStatus]}
                </Text>
            </Flexbox>
        </Flexbox>
    )
}
